<app-common-socket-logs
	[log]="currentLog"
	[title]="'Topo Logs'">
	<button class="button-general" (click)="viewData()">View</button>
</app-common-socket-logs>
